import { defineStore } from "pinia";
import { mande } from "mande";
interface coordinatedShape {
  features: Array<any>;
}

const userLocationStore = defineStore("location", {
  state: () => ({
    city: "Nairobi",
    place_name: "Nairobi, Kenya",
    lat: -1.2832533,
    long: 36.8172449,
    accuWeather: "12fd0cfe7bf443bdbc9530b06a10f1c7",
    mapBoxToken:
      "pk.eyJ1IjoiaWFubXVnZW55YSIsImEiOiJja3Y5Z2I2N24yOXB2MnVzM2V0YXpxbnpoIn0.JWu-qiW-iQEjgARRo9qBPw",
  }),
  getters: {},
  actions: {
    async setCoordinates(city: string) {
      try {
        const coordinates: coordinatedShape = await mande(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.city}.json?access_token=${this.mapBoxToken}`
        ).get("");
        this.city = city;
        this.place_name = coordinates.features[0].place_name;
        this.long = coordinates.features[0].center[0];
        this.lat = coordinates.features[0].center[1];
      } catch (error) {
        console.log('Unable to setcoordinates');
      }
    },
    async userLocation(long: number, lat: number) {
      try {
        const coordinates: coordinatedShape = await mande(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?access_token=${this.mapBoxToken}`
        ).get("");
        this.place_name = coordinates.features[0].place_name;
        this.long = long;
        this.lat = lat;
        this.city = coordinates.features[0].context[0].text;
      } catch (error) {
        console.log('Unable to set new coordinates');
      }
    },
  },
});

export default userLocationStore;
